import React from 'react';
import { observer } from 'mobx-react-lite';
import { useStore } from '../../../hooks';
import {
  showCustomToast,
  generateMeterReplacementDescription,
  openRequestInNewTab,
} from '../../../utils';
import { alertHollow, checkCircle } from '../../../assets/icons';
import { Button } from '../../ui';

export const MeterRequestButton = observer(() => {
  const { createRequest, meters, constants } = useStore();

  const createChangeMetersRequest = (): void => {
    const request = {
      ...createRequest.newRequestData,
      category: 'commercial',
      subcategory: 'chargeable',
      description: generateMeterReplacementDescription(
        meters.metersFromChecked,
        constants.requests.MeterTypeNamesShort,
        constants.requests.AreaLocations
      ),
    };

    showCustomToast({
      title: 'Создание заявки...',
      isLoading: true,
    });

    createRequest
      .createRequest(request)
      .then((res) => {
        showCustomToast({
          title: 'Создана заявка',
          subtitle: `№${res.number}`,
          subtitleClick: () => openRequestInNewTab(res._id),
          icon: checkCircle,
          closeAll: true,
        });
        meters.setCheckedMeters([]);
      })
      .catch(() => {
        showCustomToast({
          title: 'Ошибка при создании заявки',
          icon: alertHollow,
          closeAll: true,
        });
      });
  };

  return (
    <Button
      size="m"
      mode={!!meters.checkedMeters.length ? 'accent' : 'neutral'}
      variant="main"
      disabled={
        !meters.checkedMeters.length || createRequest.loading.create.pending
      }
      onClick={createChangeMetersRequest}
    >
      Создать заявку на поверку счётчиков
    </Button>
  );
});
